/**
 * Document API functions.
 * Calls real backend API exclusively.
 */

import apiClient from './client';
import type { UploadSuccessResponse, DocumentsListResponse, DocumentDetailResponse } from './types';

export async function uploadDocument(
  file: File,
  tenantId: string
): Promise<UploadSuccessResponse> {
  // Read file as base64 for Lambda handler
  const fileContent = await fileToBase64(file);

  const payload = {
    tenant_id: tenantId,
    file_name: file.name,
    file_type: file.name.split('.').pop() || 'txt',
    file_size_bytes: file.size,
    file_content: fileContent,
  };

  const response = await apiClient.post('/cti/upload', payload);
  return response.data;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Remove the data URL prefix (e.g., "data:text/plain;base64,")
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function listDocuments(tenantId: string): Promise<DocumentsListResponse> {
  const response = await apiClient.get('/cti/documents', {
    params: { tenant_id: tenantId },
  });
  return response.data;
}

export async function getDocument(
  tenantId: string,
  documentId: string
): Promise<DocumentDetailResponse> {
  const response = await apiClient.get(`/cti/documents/${documentId}`, {
    params: { tenant_id: tenantId },
  });
  return response.data;
}
